import { Booth } from '../../../../../../../interfaces/interfaces';
import { BoothAccessList } from '../../../../../../account/privilege/BoothPrivilege/BoothAccessList';
import { TabContentWrapper } from './TabContentWrapper';
const BoothUserPrivileges = ({ booth }: { booth: Booth }) => {
  return (
    <TabContentWrapper>
      <BoothAccessList boothId={booth._id} />
    </TabContentWrapper>
  );
};
export default BoothUserPrivileges;
